/* eslint-disable check-file/filename-blocklist */

import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AdvancedSearchPage = styled.main({
	'@media only screen and (max-width: 768px)': {
		padding: `0px ${token('space.300')}`,
	},
	'@media only screen and (min-width: 768px) and (max-width: 1026px)': {
		maxWidth: '720px',
		padding: `0px ${token('space.300')}`,
	},
	'@media only screen and (min-width: 1026px) and (max-width: 1280px)': {
		maxWidth: '910px',
		padding: '0px 58px',
	},
	'@media only screen and (min-width: 1280px) and (max-width: 1440px)': {
		maxWidth: '1040px',
		padding: '0px 120px',
	},
	'@media only screen and (min-width: 1440px) and (max-width: 1620px)': {
		maxWidth: '1200px',
		padding: '0px 120px',
	},
	'@media only screen and (min-width: 1620px)': {
		maxWidth: '1200px',
	},
	marginRight: 'auto',
	marginLeft: 'auto',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AdvancedSearchContainer = styled.div({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	marginTop: 0,
	justifyContent: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AdvancedSearchResults = styled.div({
	display: 'flex',
	flexGrow: 1,
	flexDirection: 'column',
	minWidth: '440px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	paddingBottom: '30px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkipToSearchFieldOuterWrapper = styled.div({
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SkipToSearchFieldWrapper = styled.div({
	position: 'absolute',
	left: '240px',
});
